import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Instructions from './containers/Instructions';
import Messages from './Messages/';
import Contacts from './Contacts/';
import EmptyContacts from './containers/EmptyContacts';
import './containers/Messaging.scss';
import { firestore } from '../../configs/environments/firebase/firebaseApp';

const mailBlue = '/img/icons/mail-blue.svg';
const mailGray = '/img/icons/mail-gray.svg';
const diaryBlue = '/img/icons/agenda-blue.svg';
const diaryGray = '/img/icons/agenda-gray.svg';
const filter = '/img/icons/filters.svg';
const messageImg = '/img/empty-state/search.svg';

const TabPanelMsg = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={5} padding="40px 0 0" maxWidth="980px">
        {children}
      </Box>
    </Typography>
  );
};

TabPanelMsg.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: 'white',
    maxWidth: '100%',
    borderRadius: 4,
    margin: 'auto',
    boxShadow: 'none',
    '@media screen and (max-width: 560px)': {
      //maxWidth: 500,
    },
  },
  root: {
    flexGrow: 1,
    backgroundColor: 'white',
    width: 680,
    margin: 'auto',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    '@media (max-width: 500px)': {
      width: '90%',
    },
    borderRadius: 4,
  },
  tabStyle: {
    height: 66,
    padding: '0 32px',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    textTransform: 'none',
    borderBottom: '1px solid #e7e7e7',
    width: '50%',
    '&$selected': {
      color: '#013957',
    },
    // '@media (max-width: 424px)': {
    //   width: 140,
    // },
  },
  selected: {},
  textColorPrimary: {
    color: '#c1c1c1',
  },
  indicator: {
    height: 2,
    backgroundColor: '#013957',
  },
  tabsContainer: {
    //width: 'fit-content',
    margin: 'auto',
    justifyContent: 'center',
  },
  scrollButtonsDesktop: {
    color: '#013957',
    display: 'none',
    '@media (max-width: 890px)': {
      display: 'inherit',
    },
    '&>svg': {
      fontSize: 24,
    },
  },
  panel: {
    position: 'relative',
    maxWidth: 980,
    minHeight: 570,
    backgroundColor: 'white',
    padding: '0 24px 0',
    borderRadius: 4,
    '@media screen and (max-width: 1150px)': {
      minHeight: 'unset',
      height: '100%',
      paddingBottom: '10px',
    },
    '@media screen and (max-width: 560px)': {
      //maxWidth: 500,
      padding: '0 8px 5px',
    },
  },
  tabWrapper: {
    display: 'contents',
  },
}));

export default function ScrollableTabsButtonAuto({
  dataRef,
  userUid,
  handleChangePage,
  page,
  totalPage,
}) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const mobileVersion = useMediaQuery('(max-width: 1279px)');

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          //variant="scrollable"
          //scrollButtons="auto"
          aria-label="full width tabs example"
          classes={{
            indicator: classes.indicator,
            flexContainer: classes.tabsContainer,
            scrollButtonsDesktop: classes.scrollButtonsDesktop,
          }}
        >
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
              wrapper: classes.tabWrapper,
            }}
            label={isMobile ? 'Mensajes' : 'Mensajes recibidos'}
            {...a11yProps(0)}
            icon={
              <img
                src={value === 0 ? mailBlue : mailGray}
                alt="icon"
                style={{ marginRight: 10, marginBottom: 0 }}
              />
            }
          ></Tab>
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
              wrapper: classes.tabWrapper,
            }}
            label={isMobile ? 'Contactos' : 'Contactos guardados'}
            {...a11yProps(1)}
            icon={
              <img
                src={value === 0 ? diaryGray : diaryBlue}
                alt="icon"
                style={{ marginRight: 10, marginBottom: 0 }}
              />
            }
          />
        </Tabs>
      </AppBar>

      {/* Messages TabPanel */}
      <TabPanelMsg className={classes.panel} value={value} index={0}>
        
        <div className="messages-container">
          <Messages
            messagesLaw={dataRef}
            userUid={userUid}
            page={page}
            totalPage={totalPage}
            handleChangePage={handleChangePage}
          />
        </div>

      </TabPanelMsg>

      {/* Contacts TabPanel */}
      <TabPanelMsg className={classes.panel} value={value} index={1}>

            <div className="messages-container">
              <Contacts messagesLaw={dataRef}  userUid={userUid} />
            </div>
      
      </TabPanelMsg>
    </div>
  );
}
